import { m } from 'motion/react';
import { itemVariants, viewPort } from '../../utils/framer';
import { Link } from './100page/TextBlock';
import LinkButton from './ui/LinkButton';

export type ContentItem = {
  __type: 'heading' | 'text' | 'link' | 'list';
  content?: string;
  links?: Link[];
  items?: string[];
  className?: string;
};

export interface FlexibleTextBlockProps {
  content: ContentItem[];
  image?: { src: string; alt: string };
  className?: string;
}

const FlexibleTextBlock: React.FC<FlexibleTextBlockProps> = ({
  content,
  className = '',
}) => {
  return (
    <m.div
      className={className}
      initial="hidden"
      whileInView="visible"
      viewport={viewPort}
    >
      {content.map((block, i) => {
        switch (block.__type) {
          case 'heading':
            return (
              <m.h2
                key={i}
                className={`text-[28px] lg:text-[36px] leading-[40px] font-semibold mb-2 lg:mb-6 ${block.className}`}
                variants={itemVariants}
              >
                {block.content}
              </m.h2>
            );

          case 'text':
            return (
              <m.p
                key={i}
                className={`text-[16px] md:text-[18px] leading-[24px] font-light ${block.className}`}
                variants={itemVariants}
              >
                {block.content}
              </m.p>
            );

          case 'link':
            return (
              <m.div
                key={i}
                className={`mt-7 flex flex-col space-y-6 ${block.className ?? ''}`}
                variants={itemVariants}
              >
                {block.links?.map((link, index) => (
                  <div
                    key={link.url ?? index}
                    className="flex justify-center md:justify-start"
                  >
                    <LinkButton
                      url={link.url}
                      text={link.label}
                      openInNewTab={link.openInNewTab}
                      widthClass={link.widthClass}
                    />
                  </div>
                ))}
              </m.div>
            );

          case 'list':
            return (
              <m.ul
                key={i}
                className={`list-outside space-y-2 my-3 pl-5 ${block.className}`}
                variants={itemVariants}
              >
                {block.items?.map((item, index) => (
                  <li
                    className="text-[16px] list-disc md:text-[18px] leading-[24px] font-light"
                    key={index}
                  >
                    {item}
                  </li>
                ))}
              </m.ul>
            );

          default:
            return null;
        }
      })}
    </m.div>
  );
};

export default FlexibleTextBlock;
